import { useEffect } from 'react'
import { shallowEqual, useSelector } from 'react-redux'

import { Link } from 'react-router-dom'
import { Button, ErrorDisplay, Input } from 'mmfintech-portal-commons'

import { isValidFunction, tr, useFormValues } from 'mmfintech-commons'

import type { CreditCardConfirmStepProps } from '../types'

export const CreditCardAvs = ({ onSubmit, onCancel }: CreditCardConfirmStepProps) => {
  const { checkoutPayError, checkoutPayFetching } = useSelector(
    ({ checkout: { checkoutPayError, checkoutPayFetching } }) => ({
      checkoutPayError,
      checkoutPayFetching
    }),
    shallowEqual
  )

  const formValues = useFormValues({
    city: {}, //{ validation: 'safe-string' },
    address: {}, //{ validation: 'safe-string' },
    state: {}, //{ validation: 'safe-string' },
    country: {}, //{ validation: 'safe-string' },
    zipcode: {} //{ validation: 'safe-string' }
  })

  const handleSubmit = () => {
    if (formValues.areValid()) {
      onSubmit({
        avs: formValues.prepare()
      })
    }
  }

  useEffect(() => {
    return () => {
      formValues.reset()
    }
  }, [])

  return (
    <>
      <div className='payment-method-wrapper' data-test='credit-card-avs'>
        {tr('CHECKOUT.CREDIT_CARD.AVS.TITLE', 'Address verification service (AVS)')}
      </div>

      <Input
        type='text'
        data-test='city-input'
        label={tr('CHECKOUT.CREDIT_CARD.AVS.CITY', 'City')}
        {...formValues.registerInput('city')}
        hideErrorLine
        autoComplete='off'
      />
      <Input
        type='text'
        data-test='address-input'
        label={tr('CHECKOUT.CREDIT_CARD.AVS.ADDRESS', 'Address')}
        {...formValues.registerInput('address')}
        hideErrorLine
        autoComplete='off'
      />
      <Input
        type='text'
        data-test='state-input'
        label={tr('CHECKOUT.CREDIT_CARD.AVS.STATE', 'State')}
        {...formValues.registerInput('state')}
        hideErrorLine
        autoComplete='off'
      />
      <Input
        type='text'
        data-test='country-input'
        label={tr('CHECKOUT.CREDIT_CARD.AVS.COUNTRY', 'Country')}
        {...formValues.registerInput('country')}
        hideErrorLine
        autoComplete='off'
      />
      <Input
        type='text'
        data-test='zipcode-input'
        label={tr('CHECKOUT.CREDIT_CARD.AVS.ZIP_CODE', 'Zip code')}
        {...formValues.registerInput('zipcode')}
        hideErrorLine
        autoComplete='off'
      />

      <ErrorDisplay error={checkoutPayError} />

      <div className='buttons'>
        <Button
          type='button'
          color='primary'
          text={tr('CHECKOUT.CREDIT_CARD.COMPLETE_BUTTON', 'Complete payment')}
          onClick={handleSubmit}
          loading={checkoutPayFetching}
          data-test='button-complete'
        />
        {isValidFunction(onCancel) ? (
          <div className='cancel-button-container mt-1'>
            <Link to='#' onClick={onCancel} data-test='cancel-button'>
              {tr('FRONTEND.BUTTONS.CANCEL', 'Cancel')}
            </Link>
          </div>
        ) : null}
      </div>
    </>
  )
}
